import { useState } from 'react'

import styles from './styles.module.css'
import { notifyErrorCustom } from '../../../utils/notify'

import { motion } from 'framer-motion'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { ForgotPasswordService, UserService } from '../../../services'
import { ArrowRigth } from '../../../assets/svgs/icons'
import { LuMail } from 'react-icons/lu'

function StepEmail({ setEmail, email, setStep }) {
  const [isLoading, setIsLoading] = useState(false)

  const navigate = useNavigate()

  const STEPS = {
    STEP_VERIFY_EMAIL: 'stepVerifyEmail',
  }

  const isValidEmail = (email) => {
    // Expressão regular para validar e-mail
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

    // Testa o e-mail recebido com o regex
    return emailRegex.test(email)
  }

  const handleNavigate = async (type) => {
    if (type === 'next') {
      if (email === '') {
        notifyErrorCustom(t('fast_publishing_email_enter_your_email_alert'))
        setIsLoading(false)
        return
      } else if (!isValidEmail(email)) {
        notifyErrorCustom(t('fast_publishing_email_invalid_format'))
        setIsLoading(false)
        return
      }

      try {
        const checkEmail = await UserService.getUserCheckEmailExists(email)

        if (checkEmail?.data?.hasGoogleId === true) {
          notifyErrorCustom(
            'Esta conta está conectada com o Google. Por isso, não é possível recuperar a senha.'
          )
          setIsLoading(false)
          return
        }
      } catch (error) {
        console.error('error checking google account before password reset', error)
      }

      const response = await ForgotPasswordService.postsendCode({
        email,
      })

      // console.log('response', response)

      setIsLoading(false)

      if (response.responseStatus === 200) {
        setStep(STEPS.STEP_VERIFY_EMAIL)
      } else {
        const backendMessage =
          response?.response?.data?.error?.message ||
          response?.response?.data?.message

        notifyErrorCustom(
          backendMessage || t('forgotPasswordStepPassword.forgot_password_error')
        )
      }
    } else {
      navigate('/SignIn')
    }
  }

  const { t } = useTranslation()
  return (
    <>
      <motion.div
        initial={{ x: '100vw' }}
        animate={{ x: 0 }}
        exit={{ x: '-100vw' }}
        transition={{ type: 'tween', duration: 0.5 }}
        className={styles.step_motion}
      >
        <div className={styles.box_step}>
          <div className={styles.box_page}>
            <h1 className={styles.step_title}>Redefinir senha</h1>

            <div className={styles.box_input_email}>
              <p className={styles.step_description}>
                Preencha o email usado no cadastro e enviaremos um código de 6
                dígitos para redefinir sua senha.
              </p>
              <span className={styles.input_label}>E-mail</span>
              <div className={styles.input_shell}>
                <span className={styles.email_icon} aria-hidden="true">
                  <LuMail size={24} color='rgba(166, 166, 178, 1)'/>
                </span>
                <input
                  className={styles.input_email}
                  type="text"
                  value={email}
                  placeholder="seu@email.com"
                  onChange={(e) => setEmail(e.currentTarget.value)}
                />
              </div>
            </div>
          </div>
          <div className={styles.box_button}>
            <button
              type="button"
              disabled={isLoading}
              className={`${styles.next_button} ${
                isLoading ? styles.next_button_loading : ''
              }`}
              onClick={() => {
                setIsLoading(true)
                handleNavigate('next')
              }}
            >
              {isLoading ? (
                <span className={styles.button_loading_content}>
                  <span className={styles.button_spinner} aria-hidden="true" />
                  <span>Carregando...</span>
                </span>
              ) : (
                <span className={styles.button_continue_content}>
                  <span>Continuar</span>
                  <span aria-hidden="true">
                    <ArrowRigth size={24} />
                  </span>
                </span>
              )}
            </button>
            <p className={styles.login_prompt}>
            Quer acessar outra conta?{' '}
              <button
                type="button"
                className={styles.login_link}
                onClick={() => handleNavigate('back')}
              >
              Voltar ao login
              </button>
            </p>
          </div>  
        </div>
      </motion.div>
    </>
  )
}

export default StepEmail
